module.exports = __webpack_public_path__ + "img/Group 31.473afe47.png";